var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, Unique, UpdateDateColumn } from 'typeorm';
let AddressBook = class AddressBook {
    id;
    address;
    userAddress;
    name;
    remark;
    disabled;
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], AddressBook.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], AddressBook.prototype, "address", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], AddressBook.prototype, "userAddress", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], AddressBook.prototype, "name", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], AddressBook.prototype, "remark", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], AddressBook.prototype, "disabled", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], AddressBook.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], AddressBook.prototype, "createdAt", void 0);
AddressBook = __decorate([
    Entity({ name: 'address_book' }),
    Unique(['address', 'userAddress'])
], AddressBook);
export { AddressBook };
//# sourceMappingURL=module.js.map